import { TimesheetStatus } from '@sdk/timesheets/api/apiTypes';
import { TimesheetEntry } from '@sdk/timesheets/types/TimesheetEntry';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Text14 from '@sdk/components/ui/typography/Text14';

import TimesheetViewModalBannerEmployee from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalBanner/TimesheetViewModalBannerEmployee';
import TimesheetViewModalBannerManager from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalBanner/TimesheetViewModalBannerManager';
import type { TimesheetViewModalBanner as GenericBannerType } from '@web/timesheets/TimesheetViewModal/timesheetViewModal.types';
import { BannerWithIconContainer } from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/modalBanner.styles';

type Props = {
  timesheetStatus: TimesheetStatus;
  isManager: boolean;
  isCurrentUsersTimesheet: boolean;
  timesheetEntries: TimesheetEntry[];
  employeeName: string;
  genericBanner?: GenericBannerType;
};
const TimesheetViewModalBanner = ({
  timesheetStatus,
  isManager,
  isCurrentUsersTimesheet,
  timesheetEntries,
  employeeName,
  genericBanner,
}: Props) => {
  if (genericBanner) {
    return (
      <BannerWithIconContainer themeColor={genericBanner.theme} alignItems="center">
        <Text14 themeColor={ThemeColorType.white} semiBold>
          {genericBanner.text}
        </Text14>
      </BannerWithIconContainer>
    );
  }

  // If by any chance an employee views timesheet that doesn't concern him, we have nothing to show in the banner
  // as there will be no action for employee to be taken.
  if (!isManager && !isCurrentUsersTimesheet) {
    return null;
  }

  if (!isManager) {
    return (
      <TimesheetViewModalBannerEmployee
        timesheetStatus={timesheetStatus}
        timesheetEntries={timesheetEntries}
      />
    );
  }

  return (
    <TimesheetViewModalBannerManager
      timesheetStatus={timesheetStatus}
      timesheetEntries={timesheetEntries}
      employeeName={employeeName}
    />
  );
};

export default TimesheetViewModalBanner;
